//membuat styled-component 

import styled, { css } from "styled-components";

/**
 * mengunakan object sebagai styled component sesuai variant 
 * file [hero, form]
 */
// const  colors = {
//     primary: "rgba(6, 214, 160, 1)",
//     secondary: "#b5179e",
// };

const Button = styled.button`
    padding: 0.8rem 2rem ;
    border: none ;
    border-radius: 10px ;
    color: #fff ;
    background-color: rgba(6, 214, 160, 1);
    cursor: pointer ;

    //akses props variant
    /** props diubah menjadi variant + refactor + theme
     */
    background-color: ${({variant, theme}) => {
        if (variant) {
            return theme.colors[variant];
        }else {
            return theme.colors.primary;
        }
    } } ;

    //short code statement
    ${(props) => props.full && css`display: block ; width: 100% ; margin-top: 2rem; `}

`;

//export button
export default Button;